import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w-100", attrs: { "data-qa": "club-success" } },
    [
      _c(VImg, {
        staticClass: "mx-auto mb-4",
        attrs: {
          src: "/static/_v1/pd/icons/ui-kit/club/club-check.svg",
          alt: "Иконка успешной записи по клубу",
          width: "72",
          height: "72",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-h5 text--text text-center mb-4" },
        [
          !_vm.isClubRegistration
            ? [
                _vm._v("\n      Оплата зачислена."),
                _c("br"),
                _vm._v(" Вы в клубе!\n    "),
              ]
            : [_vm._v("\n      Оплата зачислена\n    ")],
        ],
        2
      ),
      _vm._v(" "),
      _c("ol", { staticClass: "instructions-list text-body-1 mb-4" }, [
        _c("li", { staticClass: "instructions-list__item" }, [
          _c(
            "a",
            {
              staticClass:
                "error--text text-decoration-none d-inline-flex align-center",
              attrs: {
                rel: "noopener noreferrer",
                target: "_blank",
                href: `/club/coupon/${_vm.couponId}/file/`,
              },
              on: {
                click: function ($event) {
                  return _setup.emit("club:download-coupon")
                },
              },
            },
            [
              _c("span", { staticClass: "ui-icon-download mr-2" }),
              _vm._v(" "),
              _c("span", { staticClass: "text-decoration-underline" }, [
                _vm._v("Скачайте опцион на скидку"),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "instructions-list__item" }, [
          _vm._v("\n      В день приёма покажите опцион в клинике\n    "),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "instructions-list__item" }, [
          _vm._v(
            "\n      Оплатите в клинике " +
              _vm._s(_setup.getFormattedPrice(_vm.clubLpuPrice)) +
              "\n    "
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }